/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Eon Restore Job type. 
*/
export enum RestoreJobType {
  RestoreJobTypeUnspecified = 'RESTORE_JOB_TYPE_UNSPECIFIED',
  AwsS3ObjectRestore = 'AWS_S3_OBJECT_RESTORE',
  AwsS3BucketRestore = 'AWS_S3_BUCKET_RESTORE',
  AwsEc2FileRestore = 'AWS_EC2_FILE_RESTORE',
  AwsEc2InstanceRestore = 'AWS_EC2_INSTANCE_RESTORE',
  AwsEc2AmiConvert = 'AWS_EC2_AMI_CONVERT',
  AwsEc2EbsVolumeRestore = 'AWS_EC2_EBS_VOLUME_RESTORE',
  AwsEc2EbsSnapshotConvert = 'AWS_EC2_EBS_SNAPSHOT_CONVERT',
  AwsRdsInstanceRestore = 'AWS_RDS_INSTANCE_RESTORE',
  AwsEksNamespaceRestore = 'AWS_EKS_NAMESPACE_RESTORE',
  AwsEksFileRestore = 'AWS_EKS_FILE_RESTORE',
  AwsDynamoDbTableRestore = 'AWS_DYNAMO_DB_TABLE_RESTORE',
  AzureStorageAccountRestore = 'AZURE_STORAGE_ACCOUNT_RESTORE',
  AzureStorageAccountBlobRestore = 'AZURE_STORAGE_ACCOUNT_BLOB_RESTORE',
  AzureVmFileRestore = 'AZURE_VM_FILE_RESTORE',
  AzureVmDiskRestore = 'AZURE_VM_DISK_RESTORE',
  AzureVmInstanceRestore = 'AZURE_VM_INSTANCE_RESTORE',
  GcpCloudStorageBucketRestore = 'GCP_CLOUD_STORAGE_BUCKET_RESTORE',
  GcpCloudStorageObjectRestore = 'GCP_CLOUD_STORAGE_OBJECT_RESTORE',
  GcpComputeEngineFileRestore = 'GCP_COMPUTE_ENGINE_FILE_RESTORE',
  GcpComputeEngineDiskRestore = 'GCP_COMPUTE_ENGINE_DISK_RESTORE',
  GcpComputeEngineInstanceRestore = 'GCP_COMPUTE_ENGINE_INSTANCE_RESTORE',
  GcpCloudSqlDatabaseRestore = 'GCP_CLOUD_SQL_DATABASE_RESTORE'
}
